// 📺 SCR — Screen detection drop-killer
// Viewport + touch + dataset en <html> para CSS/JS reactivo.

import { MDQ, match, listen } from '../🧪MXS/🧪MXS.js'

export const SCR = {
  w: window.innerWidth,
  h: window.innerHeight,
  touch: false,
  isPc:   false,
  isPT:   false,
  reduced: false,
}

const html = document.documentElement

function update() {
  SCR.w = window.innerWidth
  SCR.h = window.innerHeight
  SCR.isPc = match('isPc')
  SCR.isPT = match('isPT')
  SCR.reduced = match('reduced')

  html.classList.toggle('is-pc',  SCR.isPc)
  html.classList.toggle('is-pt',  SCR.isPT)
  html.classList.toggle('is-touch', SCR.touch)
  html.classList.toggle('is-reduced', SCR.reduced)
}

export function initSCR() {
  SCR.touch = 'ontouchstart' in window || navigator.maxTouchPoints > 0
  update()

  let rafId = 0
  window.addEventListener('resize', () => {
    cancelAnimationFrame(rafId)
    rafId = requestAnimationFrame(update)
  })

  listen('reduced', (m) => { SCR.reduced = m; update() })
  listen('isPc',    (m) => { SCR.isPc = m;    update() })
}

export default SCR
